import { render, staticRenderFns } from "./Cardweekendall.vue?vue&type=template&id=5790bd6f&scoped=true&"
import script from "./Cardweekendall.vue?vue&type=script&lang=js&"
export * from "./Cardweekendall.vue?vue&type=script&lang=js&"
import style0 from "./Cardweekendall.vue?vue&type=style&index=0&id=5790bd6f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5790bd6f",
  null
  
)

export default component.exports